<div class="content__inner">
    <header class="content__title">
        <h1>{{ "salesmanagerorders.detail.title" | translate }}</h1>

        <div class="actions">
            <button (click)="back()" class="btn btn-secondary btn--icon-text"><i class="zmdi zmdi-arrow-back"></i> {{ "global.buttons.back" | translate }}</button>
            <button class="float-right btn btn-outline-secondary btn--icon-text" *appHasPermission="'SALESMANAGERORDERS.READ'" (click)="downloadSalesManagerOrdersCSV()">
                <i class="zmdi zmdi-download"></i> {{ "salesmanagerorders.detail.export" | translate }}
            </button>
        </div>
    </header>

    <div class="card" *appHasPermission="'SALESMANAGERORDERS.READ'">
        <div class="card-body" *ngIf="salesManagerOrder !== null">
            <div class="col-md-12" id="salesmanager-details" *ngIf="salesManagerOrder.salesManager">
                <div class="form-group">
                    <h6>{{ "salesmanagerorders.props.salesmanager" | translate }}</h6>
                    <div [innerHtml]="salesManagerOrder.salesManager.htmlFormatUser()"></div>
                </div>
            </div>
            <div class="col-md-4" id="distributor-details" *ngIf="salesManagerOrder.distributor">
                <div class="form-group">
                    <h6>{{ "salesmanagerorders.props.distributor" | translate }}</h6>
                    <div [innerHtml]="salesManagerOrder.distributor.htmlFormatUser()"></div>
                </div>
            </div>

            <!-- Table -->
            <table mat-table [dataSource]="salesManagerOrder.orderPositions">
                <ng-container matColumnDef="materialNumber">
                    <th mat-header-cell *matHeaderCellDef>{{ "salesmanagerorders.props.materialnumber" | translate }}</th>
                    <td mat-cell *matCellDef="let row">{{ row.item.materialNumber }}</td>
                </ng-container>

                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef>{{ "salesmanagerorders.props.name" | translate }}</th>
                    <td mat-cell *matCellDef="let row">{{ row.item.name }}</td>
                </ng-container>

                <ng-container matColumnDef="category">
                    <th mat-header-cell *matHeaderCellDef>{{ "salesmanagerorders.props.category" | translate }}</th>
                    <td mat-cell *matCellDef="let row">{{ row.getCategoryI18N() | translate }}</td>
                </ng-container>

                <ng-container matColumnDef="quantity">
                    <th mat-header-cell *matHeaderCellDef>{{ "salesmanagerorders.props.quantity" | translate }}</th>
                    <td mat-cell *matCellDef="let row">{{ row.quantity }}</td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
        </div>
    </div>
</div>
